import { RefObject, useEffect, useState } from 'react';

export function useIsOnScreen(
  ref: RefObject<HTMLElement | null>,
  hasBeenOnScreen = false,
  rootMargin = '0px',
) {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(
    () => {
      const currentRef = ref.current;

      if (!hasBeenOnScreen) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            // Update our state when observer callback fires
            setIsIntersecting(entry?.isIntersecting ?? false);
          },
          {
            rootMargin,
          },
        );
        if (currentRef) {
          observer.observe(currentRef);
        }

        return () => {
          if (currentRef) {
            observer.unobserve(currentRef);
          }
        };
      }
    },
    // Empty array ensures that effect is only run on mount and unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return isIntersecting;
}
